<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    colspan: number
    showActions: boolean
    label?: string
    inset?: boolean
  }>(),
  {
    label: undefined,
    inset: false,
  },
)

defineEmits<{
  add: []
}>()

const { t } = useI18n({ useScope: 'local' })

const addLabel = computed(() => props.label ?? t('addInline'))
</script>

<template>
  <tr>
    <td class="p-0 align-middle" :class="inset ? 'pl-3' : ''" :colspan="colspan">
      <button
        type="button"
        class="group/add text-ink-3 hover:text-action hover:bg-surface-2 flex w-full cursor-pointer items-center gap-2 rounded-md border-none bg-transparent px-3 py-3 text-left text-base transition-colors duration-150"
        @click="$emit('add')">
        <span
          class="flex h-5 w-5 flex-none items-center justify-center rounded-full border-[1.5px] border-dashed border-current text-xs leading-none group-hover/add:border-solid">
          +
        </span>
        {{ addLabel }}
      </button>
    </td>

    <td v-if="showActions" class="w-9 px-2 py-1.5" :class="inset ? 'pr-6' : ''"></td>
  </tr>
</template>

<i18n lang="json">
{
  "de": {
    "addInline": "Neue Position hinzufügen …"
  },
  "en": {
    "addInline": "Add position …"
  }
}
</i18n>
